export default "__VITE_ASSET__BjX2A6Sr__"